import { render, staticRenderFns } from "./ManageForm5.vue?vue&type=template&id=4aaef180&"
import script from "./ManageForm5.vue?vue&type=script&lang=js&"
export * from "./ManageForm5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports